// Connection is now handled by wagmi — see src/wagmiConfig.js
// Kept as an empty stub so any remaining imports don't break at build time.
export const connectorsByName = {};

export const getLibraryForSign = (provider) => provider;
export const getLibrary = (provider) => provider;
